import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { Location } from "@angular/common";
import { environment } from '../../../environments/environment';
import { CertificatesService } from '../../services/certificates.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    styleUrls: ['./auth.styles.css'],
    templateUrl: './auth.template.html'
})

export class AuthComponent implements OnInit, OnDestroy {

    public error: string;
    public login: string;
    public pass: string;
    public certsList: object[];
    public selectedCert: string = null;
    private location: Location;
    public without_signature_mode: boolean = environment.without_signature_mode;

    private unsubscribe$ = new Subject();
    constructor(
        private router: Router,
        private service: AuthService,
        private certificatesService: CertificatesService,
    ) {}

    ngOnInit() {
        if (!this.without_signature_mode) {
          this.certificatesService.getCertsList()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(list => this.certsList = list);
        }
    }

    ngOnDestroy(): void {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }

  log_in() {
        if (this.selectedCert) {
            this.certificatesService.signHash(this.selectedCert, this.certificatesService.base64encode('test'))
            .then((signature) => {
                    this.service.log_in_by_signature(signature).subscribe(
                        data => {
                            this.service.set_token(data['access_token']);
                            if (this.service.inactivity_logout) {
                                this.service.inactivity_logout = false;
                                this.location.back();
                            } else {
                              this.router.navigateByUrl('/');
                            }
                        },
                        error => console.log(error.message)
                    );
                },
                (error) => {
                    console.error('error', error);
                }
            );
        } else {
            this.service.log_in(this.login, this.pass).subscribe(
                data => {
                    if (Number.parseInt(data['code']) === 1 && data['access_token'].length) {
                        this.service.set_token(data['access_token']);
                        if (this.service.inactivity_logout) {
                            this.service.inactivity_logout = false;
                            this.location.back();
                        } else {
                          this.router.navigateByUrl('/');
                        }
                    } else {
                      this.error = data['message'];
                    }
                },
                error => console.log(error.message)
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/auth.component.ts